import React from 'react';

import { QUERY_PARAMS } from '@futrli/shared-services';

import { OnboardingIntro } from '../components/onboarding-intro';

export const SageidOnboardingContainer = () => {
  const searchParams = new URLSearchParams(location.search);
  const workspaceId = searchParams.get(QUERY_PARAMS.WORKSPACE_ID);

  if (!workspaceId) {
    return null;
  }

  return <OnboardingIntro workspaceId={workspaceId} />;
};
